import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { message } from 'antd';
import { NftCheckoutForm } from 'components/Shared/NftCheckoutForm';
import * as Styled from './styles';
import { getPaymentIntent } from 'appRedux/restApi';
import { STRIPE_KEY } from 'constants/payment/stripe-keys';

// Type guard implemented
const stripePromise = loadStripe(STRIPE_KEY);

type NftCardPaymentProps = {
  id: number | undefined;
  url_key: string | undefined;
  externalHandleSuccess?: () => void;
  isFullUrl?: boolean;
};

export const NftCardPayment = ({
  id,
  url_key,
  externalHandleSuccess,
  isFullUrl
}: NftCardPaymentProps) => {
  const [clientSecret, setClientSecret] = useState<string | undefined>();

  // Create PaymentIntent as soon as the page loads
  useEffect(() => {
    (async () => {
      const paymentIntent = await getPaymentIntent(id, (_success, error) => {
        if (error) {
          message.error(error);
        }
      });
      if (paymentIntent === undefined) {
        externalHandleSuccess?.();
        return;
      }
      localStorage.setItem('paymentIntent', JSON.stringify(paymentIntent));
      setClientSecret(paymentIntent.client_secret);
    })();
  }, []);

  const options = {
    clientSecret
  };

  return (
    <Styled.FormContainer>
      {clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <NftCheckoutForm url_key={url_key} isFullUrl={isFullUrl} />
        </Elements>
      )}
    </Styled.FormContainer>
  );
};
